import localStore from 'store';

export function saveState(state, key) {
  const nextState = state.set('$saved', Date.now());
  localStore.set(key, nextState.toJS());
  return nextState;
}
